import { useState } from 'react';
import Select from '../ui/Select';

interface MonthSelectorProps {
  onMonthChange: (month: string) => void;
  selectedMonth?: string;
}

const MESES = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
];

export default function MonthSelector({ onMonthChange, selectedMonth }: MonthSelectorProps) {
  const [isOpen] = useState(false);

  return (
    <div className="relative">
      <label className="block text-sm font-bold mb-3">Mês da Sorte</label>
      <Select
        value={selectedMonth || ''}
        onChange={(v) => onMonthChange(String(v))}
        options={MESES.map(m => ({ value: m, label: m }))}
        placeholder="Selecione o mês da sorte"
      />
      {!selectedMonth && (
        <p className="mt-2 text-sm text-red-400">⚠️ Mês da sorte é obrigatório para Dia de Sorte</p>
      )}
    </div>
  );
}
